import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const Essentital: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Essentital');
    return (
        <div className={`${styles.Essentital} GtmModuleData-section`} data-section-id="Essentital" id="Essentital">
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="eco-content">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1753683859574/pc.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1753683860024/pad.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1753683859764/h5.jpg"
                />
            </div>
            <div className="trail-layout footer-desc">{t('footer_desc')}</div>
        </div>
    );
};

export default Essentital;
